import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Linkify from "react-linkify";
import "./SubjectBar.module.scss";

/**
 * Import components
 */
import Subject from "components/UI/Subject/Subject";

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

let date = [""];

class HomeworkBar extends Component {
    constructor() {
        super();

        this.state = {
            day: "",
            month: "",
            year: "",
            showPopup: false
        };

        this.togglePopup = this.togglePopup.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.setDay = this.setDay.bind(this);
    }

    componentDidMount() {
        date = this.props.homework.date.split("-");
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            document.removeEventListener("mousedown", this.handleClickOutside);
            this.setState({
                showPopup: false
            });
        }
    }

    togglePopup() {
        if (!this.state.showPopup) {
            document.addEventListener("mousedown", this.handleClickOutside);
        } else {
            document.removeEventListener("mousedown", this.handleClickOutside);
        }

        this.setState(prevState => {
            return {
                showPopup: !prevState.showPopup
            };
        });
    }

    setDay() {
        date = this.props.homework.date.split("-");
        let result = "";
        let day = date[2];
        if (day[0] == "0") {
            result = day[1];
        } else {
            result = day;
        }
        return result;
    }

    render() {
        return (
            <>
                <div styleName="outer-wrapper">
                    <div
                        styleName="homework-card-wrapper"
                        style={this.props.style}
                    >
                        <div styleName="left" style={{ width: "100%" }}>
                            <Subject
                                color={
                                    this.props.color
                                        ? this.props.color
                                        : "#94bfcf"
                                }
                                abbreviation={this.props.abbreviation}
                                style={{ marginLeft: "10px" }}
                            />
                            <div
                                styleName="homework-details"
                                style={{ display: "flex" }}
                            >
                                <Fragment>
                                    <p styleName="type">
                                        {this.props.homework.type == "make" &&
                                            "M"}
                                        {this.props.homework.type == "learn" &&
                                            "L"}
                                        {this.props.homework.type ==
                                            "make_learn" && (
                                            <Fragment>
                                                M<br />L
                                            </Fragment>
                                        )}
                                        {this.props.homework.type == "read" && (
                                            <Fragment>
                                                L<br />Z
                                            </Fragment>
                                        )}
                                    </p>
                                    <div styleName="description1">
                                        {!this.props.homework.mark ? (
                                            <p>
                                                {
                                                    this.props.homework
                                                        .description
                                                }{" "}
                                            </p>
                                        ) : (
                                            <p>
                                                <mark styleName="mark">
                                                    {
                                                        this.props.homework
                                                            .description
                                                    }{" "}
                                                </mark>
                                            </p>
                                        )}
                                    </div>
                                </Fragment>
                            </div>
                            <p styleName="date2">
                                {/* {
                            () => {
                                let result = '';
                                let day = date[2];
                                if (day[0] == '0') {
                                    result = day[1];
                                } else {
                                    result = day;
                                }
                                return result;
                            }
                        } */}

                                {/* {date[2]} */}
                                {this.setDay()}

                                {date[1] == "01" && " januari"}
                                {date[1] == "02" && " februari"}
                                {date[1] == "03" && " maart"}
                                {date[1] == "04" && " april"}
                                {date[1] == "05" && " mei"}
                                {date[1] == "06" && " juni"}
                                {date[1] == "07" && " Juli"}
                                {date[1] == "08" && " augustus"}
                                {date[1] == "09" && " september"}
                                {date[1] == "10" && " oktober"}
                                {date[1] == "11" && " november"}
                                {date[1] == "12" && " december"}
                            </p>
                        </div>
                        {!this.props.disableContextMenu && (
                            <Fragment>
                                <FontAwesomeIcon
                                    styleName="icon"
                                    icon={["far", "ellipsis-h"]}
                                    onClick={this.togglePopup}
                                />
                                <div
                                    styleName={`settings-popup ${
                                        this.state.showPopup ? "" : "hidden"
                                    }`}
                                    style={
                                        this.props.isRecurring
                                            ? { height: "100px" }
                                            : { height: "75px" }
                                    }
                                    ref={this.setWrapperRef}
                                >
                                    <div
                                        styleName="setting"
                                        onClick={() =>
                                            this.props.handleSubjectEditClick()
                                        }
                                    >
                                        <p>Vak bewerken</p>
                                    </div>
                                    <div
                                        styleName="setting"
                                        onClick={() =>
                                            this.props.handleDetailsEditClick()
                                        }
                                    >
                                        <p>Uur instellingen</p>
                                    </div>
                                    {this.props.isRecurring ? (
                                        <Fragment>
                                            <div
                                                styleName="setting red"
                                                onClick={() =>
                                                    this.props.destroyItem(
                                                        "single"
                                                    )
                                                }
                                            >
                                                <p>
                                                    Verwijder alleen op deze
                                                    plaats
                                                </p>
                                            </div>
                                            <div
                                                styleName="setting red"
                                                onClick={() =>
                                                    this.props.destroyItem(
                                                        "future"
                                                    )
                                                }
                                            >
                                                <p>
                                                    Verwijder vanaf hier overal
                                                </p>
                                            </div>
                                        </Fragment>
                                    ) : (
                                        <div
                                            styleName="setting red"
                                            onClick={() =>
                                                this.props.destroyItem("single")
                                            }
                                        >
                                            <p>Verwijder</p>
                                        </div>
                                    )}
                                </div>
                            </Fragment>
                        )}
                    </div>
                    {this.props.note ? (
                        <p styleName="note">
                            <Linkify>{this.props.note}</Linkify>
                        </p>
                    ) : null}
                </div>
                {this.props.image ? (
                    <div
                        onClick={() => window.open(this.props.image)}
                        styleName="imageLink "
                    >
                        <FontAwesomeIcon icon={["fal", "paperclip"]} />{" "}
                        <span>Bijlage bekijken</span>
                    </div>
                ) : null}
            </>
        );
    }
}

export default HomeworkBar;
